<template>
  <vue-select
      :options="paginated"
      :filterable="false"
      :label="label"
      :placeholder="placeholder"
      :reduce="option =>  option[id]"
      @open="onOpen"
      @close="onClose"
      @search="onSearch"
      @input="onInput"
      :value="value"
      append-to-body
      :calculate-position="calculatePosition"
      :components="{
        OpenIndicator
      }"
  >
    <template v-if="searchMinimum" slot="no-options">
      type to search..
    </template>
    <template #list-footer>
      <li ref="load" class="loader" v-show="hasNextPage">
        Loading more options...
      </li>
    </template>
  </vue-select>
</template>

<script>
import OpenIndicator from '@/components/inputs/v-select/open-indicator'
export default {
  name: "vue-select-ajax",
  props:{
    value: {
      type: [String, Number],
      default: undefined
    },
    id:{
      type: String,
      default: 'id',
    },
    label: {
      type: String,
      default: 'name'
    },
    //example labelHandler function(labelValue, model){ return formatting here}
    labelHandler: {type: Function, default: undefined},
    url: {
      type: String,
      required: true
    },
    params:{
      type: Object,
      default: function (){
        return {}
      }
    },
    placeholder:{
      type: String,
      default: '',
    },
    minSeachCharacter:{
      type: [String, Number],
      default: 0,
    }
  },
  data(){
    return {
      observer: null,
      limit: 10,
      search: '',
      model:[],
      selectedModel: {},
      page: 1,
      lastPage: 1,
      perPage: 10,
      from: 1,
      total: 1,
      debounceFetchOptions: this.lodash.debounce(this.fetchOptions, 350),
      debounceFetchValueOption: this.lodash.debounce(this.fetchValueOption, 350),
      OpenIndicator,
    }
  },
  mounted () {
    this.observer = new IntersectionObserver(this.infiniteScroll);
    if (!this.searchMinimum){
      this.debounceFetchOptions()
    }

    if (this.value){
      this.fetchValueOption();
    }
  },
  watch:{
    value(newValue, oldValue){
      if (!this.lodash.isEqual(newValue, oldValue)){
        this.fetchValueOption();
      }
    },
    url(newValue, oldValue){
      if (!this.lodash.isEqual(newValue, oldValue)){
        this.fetchOptions();
      }
    },
  },
  computed: {
    searchMinimum(){
      return this.search.length < this.minSeachCharacter;
    },
    paginated () {
      let paginatedOption = this.lodash.cloneDeep(this.model);
      if (Object.keys(this.selectedModel).length){
        paginatedOption = paginatedOption.concat([this.selectedModel])
      }

      paginatedOption = paginatedOption.map((option)=>{
        if (this.labelHandler){
          option[this.label] = this.labelHandler(option[this.label], option);
        }
        if (typeof this.value == 'string') option[this.id] = option[this.id].toString()
        else if (typeof this.value == 'number') option[this.id] = parseFloat(option[this.id])

        return option
      })

      return this.lodash.uniqBy(paginatedOption, this.id);
    },
    hasNextPage () {
      return this.page < this.lastPage;
    },
  },
  methods: {
    calculatePosition(dropdownList, component, { width, top, left }) {
      dropdownList.style.width = width;
      dropdownList.style.left = left;
      dropdownList.style.position = 'absolute';
      dropdownList.style.top = top;
      dropdownList.style.visibility = 'hidden';

      this.$nextTick(() => {
        const dropdownRect = dropdownList.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        if (dropdownRect.bottom > viewportHeight) {
          const toggleRect = component.$refs.toggle.getBoundingClientRect();
          dropdownList.style.top = `${toggleRect.top + window.scrollY - dropdownRect.height}px`;
        }

        dropdownList.style.visibility = 'visible';
      });
    },
    onInput(event){
      this.debounceFetchValueOption(event);
      this.$emit('input', event);
    },
    async onOpen () {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observer.disconnect();
    },
    onSearch(search) {
      this.search = search
      this.debounceFetchOptions(search);
    },
    async infiniteScroll ([{isIntersecting, target}]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;
        await this.debounceFetchOptions(this.search, this.page+1);
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
    fetchValueOption(value = this.value) {
      if (!value) {
        this.selectedModel = {}
        return
      }

      let params = {
        ...this.params
      }
      if (this.id === 'id'){
        return this.$axios.get(`${this.url}/${value}`, {
          params
        }).then((response)=>{
          const { data: { data } } = response;
          this.selectedModel = data;
        })
      }else{
        params[this.id+'__in'] = value
        return this.$axios.get(this.url, {
          params
        }).then((response)=>{
          const { data: { data } } = response;
          this.selectedModel = data[0];
        })
      }
    },
    fetchOptions(search = '', page = 1) {
      if (this.searchMinimum) {
        this.model = [];
        this.page = 1;
        this.perPage = 10;
        this.lastPage = 1;
        this.from = 1;
        this.total = 1;
        return
      }

      return this.$axios.get(this.url, {
        params:{
          search,
          page,
          ...this.params
        }
      }).then((response)=>{
        const { data: { data, meta } } = response;
        if (page > 1){
          this.model = this.model.concat(data);
        }else{
          this.model = data;
        }
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.lastPage = Number(meta.last_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

      })
    }
  }
}
</script>

<style lang="scss">
  .is-invalid .v-select .vs__dropdown-toggle{
    border: #F14250 solid 1px;
  }
</style>
